import { render, staticRenderFns } from "./EditCard.vue?vue&type=template&id=773d1836&scoped=true"
import script from "./EditCard.vue?vue&type=script&lang=js"
export * from "./EditCard.vue?vue&type=script&lang=js"
import style0 from "./EditCard.vue?vue&type=style&index=0&id=773d1836&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773d1836",
  null
  
)

export default component.exports